import { z } from 'zod';
import type { AISchemaField, UISchemaField } from '../types/index';

export const socialProofAISchema: AISchemaField[] = [
  { name: 'eyebrow', type: 'string', required: false, max: 40 },
  { name: 'quote', type: 'string', required: false, max: 240 },
  { name: 'quoteSource', type: 'string', required: false, max: 60 },
  {
    name: 'logos',
    type: 'array<object>',
    required: false,
    fields: [
      { name: 'name', type: 'string', required: true, max: 40 },
      { name: 'image', type: 'image_url', required: false },
    ],
  },
];

export const socialProofUISchema: UISchemaField[] = [
  { name: 'eyebrow', type: 'text', label: 'Eyebrow', max: 40 },
  { name: 'quote', type: 'textarea', label: 'Press quote', max: 240 },
  { name: 'quoteSource', type: 'text', label: 'Quote source', max: 60 },
  { name: 'logos', type: 'logo_list', label: 'Logos' },
];

export const socialProofZodSchema = z.object({
  eyebrow: z.string().max(40).optional().nullable(),
  quote: z.string().max(240).optional().nullable(),
  quoteSource: z.string().max(60).optional().nullable(),
  logos: z
    .array(
      z.object({
        name: z.string().max(40),
        image: z.string().optional().nullable(),
      }),
    )
    .optional()
    .nullable(),
});

export type SocialProofContent = z.infer<typeof socialProofZodSchema>;

export const socialProofSample: SocialProofContent = {
  eyebrow: 'Trusted globally',
  quote: '"The most exciting hardware launch of the year."',
  quoteSource: 'Wired',
  logos: [
    { name: 'WIRED', image: null },
    { name: 'VERGE', image: null },
    { name: 'FAST CO.', image: null },
    { name: 'DEZEEN', image: null },
  ],
};
